import React, {useMemo, useState} from "react";
import {triggerLabels} from "configuration/specs";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import Skeleton from "connectui/component/display/Skeleton";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import AutoMessageItem from "../../conversations/automessages/AutoMessageItem";
import NotificationPanel from "components/Panels/NotificationPanel";

const useStyles = (theme) =>
  buildStyles({
    container: {
      width: "100%",
      height: "100%",
      padding: theme.spacing(5, 4),
      overflow: "auto",
      backgroundColor: theme.colors.gray50,
      "&::-webkit-scrollbar": {width: "0!important"},
    },
  });

const AutoMessagesPanel = ({
  scheduledMessages = {data: {}, total: 0},
  skeleton = {enabled: false},
  guestId,
}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const {experienceTypes, channels} = useMemo(() => {
    const types = [];
    const actionIDs = {};
    Object.keys(scheduledMessages.data).forEach((type) => {
      types.push(type);
      scheduledMessages.data[type].forEach((schMsgData) => {
        actionIDs[schMsgData.hash] = schMsgData.data.map((experience) => ({
          id: experience.action.action_id,
          disabled: !experience.meets_conditions,
        }));
      });
    });

    return {experienceTypes: types, channels: actionIDs};
  }, [scheduledMessages]);

  return (
    <>
      {/* START------REPLACE THIS DRAWER WITH NEW MODAL ONCE ITS READY TO IMPLEMENT */}
      <NotificationPanel
        selectedNotification={selectedMessage}
        guestId={guestId}
        setLoading={() => {}}
        onClose={() => setSelectedMessage(null)}
      />
      {/* END------REPLACE THIS DRAWER WITH NEW MODAL ONCE ITS READY TO IMPLEMENT */}
      <FlexContainer
        flexDirection="column"
        alignItems={
          !scheduledMessages.total && !skeleton.enabled
            ? "center"
            : "flex-start"
        }
        justifyContent={
          !scheduledMessages.total && !skeleton.enabled
            ? "center"
            : "flex-start"
        }
        gap={theme.spacing(8)}
        className={classes.container}
      >
        {skeleton.enabled ? (
          <>
            {Array.from({length: 2}).map((_, index) => (
              <FlexContainer
                key={index}
                flexDirection="column"
                gap={theme.spacing(4)}
                sx={{width: "100%"}}
              >
                <Skeleton
                  width={"90px"}
                  height={"20px"}
                  style={{borderRadius: `${theme.radius.lg}px`}}
                />
                <Skeleton
                  width={"100%"}
                  height={"88px"}
                  style={{borderRadius: `${theme.radius.lg}px`}}
                />
                <Skeleton
                  width={"100%"}
                  height={"88px"}
                  style={{borderRadius: `${theme.radius.lg}px`}}
                />
              </FlexContainer>
            ))}
          </>
        ) : !scheduledMessages.total ? (
          <Text variant="textLG" color="gray400">
            {"No scheduled messages yet"}
          </Text>
        ) : (
          <FlexContainer
            flexDirection="column"
            gap={theme.spacing(8)}
            sx={{width: "100%", height: "100%"}}
          >
            {experienceTypes.map((type) => (
              <FlexContainer
                key={type}
                flexDirection="column"
                gap={theme.spacing(4)}
                sx={{width: "100%"}}
              >
                <Text variant="textSM" weight="semibold">
                  {triggerLabels[type]?.name}
                </Text>
                {scheduledMessages.data[type].map((msg) => (
                  <AutoMessageItem
                    key={msg.hash}
                    message={msg}
                    channels={channels}
                    onClick={() => setSelectedMessage({data: msg.data})}
                  />
                ))}
              </FlexContainer>
            ))}
          </FlexContainer>
        )}
      </FlexContainer>
    </>
  );
};

export default AutoMessagesPanel;
